export default __webpack_public_path__ + "static/MediaContentOne-3297ec534aebef8850879c686543300f.webp";